import request from '@/utils/request'

export function getAFLocalList(params) {
    return request({
        url: `/afauth/${params}`,
        method: 'GET'
    })
}

export function getAFAppsList(params) {
    return request({
        url: `/afauth/af_apps/`,
        method: 'GET'
    })
}


export function getAFEditionsList(params) {
  return request({
      url: `/afauth/af_editions/`,
      method: 'GET'
  })
}

export function getAFAllList(params) {
  return request({
      url: `/afauth/all/${params}`,
      method: 'GET'
  })
}


export function localAppDetail(data){
  return request({
    url: '/afauth/app_detail/',
    method:'POST',
    data
  })
}

export function localAppInfo(data){
  return request({
    url: '/afauth/apps_info/',
    method:'POST',
    data
  })
}


export function localBindAuth(data){
  return request({
    url: '/afauth/bind_auth/',
    method:'POST',
    data
  })
}


export function localBuyAuth(data){
  return request({
    url: '/afauth/buy/',
    method:'POST',
    data
  })
}

export function localBuyPriceAuth(data){
  return request({
    url: '/afauth/buy_price/',
    method:'POST',
    data
  })
}


export function localCheckAuth(data){
  return request({
    url: '/afauth/check_auth/',
    method:'POST',
    data
  })
}


export function trailAFLocal(data){
  return request({
    url: '/afauth/trail/',
    method:'POST',
    data
  })
}

export function trailAFAppLocal(data){
  return request({
    url: '/afapp_auth/trail/',
    method:'POST',
    data
  })
}


export function AFLocalVerifyCode(data){
  return request({
    url: '/afauth/verify_code/',
    method:'POST',
    data
  })
}


export function AFLocalRead(id){
  return request({
    url: `/afauth/${id}/`,
    method:'GET',
  })
}

export function AFLocalUpdate(id,data){
  return request({
    url: `/afauth/${id}/`,
    method:'PATCH',
    data
  })
}


export function AFLocalAdminDelay(id,data){
  return request({
    url: `/afauth/${id}/admin_delay/`,
    method:'POST',
    data
  })
}

export function AFLocalDelay(id){
  return request({
    url: `/afauth/${id}/delay/`,
    method:'GET'
  })
}


export function AFLocalModify(id,data){
  return request({
    url: `/afauth/${id}/modify/`,
    method:'POST',
    data
  })
}

export function AFLocalModifyPrice(id,data){
  return request({
    url: `/afauth/${id}/modify_price/`,
    method:'POST',
    data
  })
}

export function AFLocalTransfer(id,data){
  console.log(id,data);
  
  return request({
    url: `/afauth/${id}/transfer/`,
    method:'POST',
    data
  })
}



export function localBuyAppPriceAuth(data){
  return request({
    url: '/afapp_auth/buy_price/',
    method:'POST',
    data
  })
}
export function localBuyAppAuth(data){
  return request({
    url: '/afapp_auth/buy/',
    method:'POST',
    data
  })
}
export function localtrailAppAuth(data){
  return request({
    url: '/afapp_auth/trail/',
    method:'POST',
    data
  })
}

export function getAFOrdersApps(id){
  return request({
    url: `/afauth/${id}/orders_apps/`,
    method:'GET'
  })
}

export function AFAppLocalAdminDelay(id,data){
  return request({
    url: `/afapp_auth/${id}/admin_delay/`,
    method:'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/afLocal.js